<script>
    import { messages } from "./stores/messages";
    import { doc } from "firebase/firestore";
    import { onDestroy, onMount } from "svelte";
    import { getTimeAgo } from "./utils";
    import { containsRTLChars } from "./utils";
    import { isMobile } from "./utils";

    const width = window.innerWidth;
    let items;
    let singleStripLength = 0;
    let offset = 0;
    let speed = -1.5;
    let autoScroll = true;
    let xm = 0;
    let touchXLast;
    let us_messages;

    function buildStrip() {
        items.innerHTML = "";
        if ($messages.length == 0) return;

        //add first strip and calculate width
        $messages.forEach((msg) => {
            items.appendChild(buildItem(msg));
        });

        singleStripLength = items.getBoundingClientRect().width;

        //add more strips until the width is enough
        while (items.getBoundingClientRect().width < width * 2) {
            $messages.forEach((msg) => {
                items.appendChild(buildItem(msg));
            });
        }
    }

    function buildItem(message) {
        const item = document.createElement("div");
        item.className = "messages-item";

        const profilePic = document.createElement("img");
        profilePic.src = `https://api.dicebear.com/9.x/miniavs/svg?seed=${message.userFp}`;
        profilePic.alt = "user emoji icon";
        profilePic.className = "messages-img";
        item.appendChild(profilePic);

        const details = document.createElement("div");
        details.className = "messages-details";
        item.appendChild(details);

        const msg = document.createElement("div");
        msg.className = "messages-msg";
        msg.style = `direction: ${containsRTLChars(message.msg) ? "rtl" : "ltr"}`;
        msg.innerText = message.msg;
        details.appendChild(msg);

        const date = document.createElement("div");
        date.className = "messages-date";
        date.innerText = message.timestamp ? getTimeAgo(message.timestamp) : "";
        details.appendChild(date);

        return item;
    }

    async function animate() {
        if (!items) return;
        if (autoScroll) {
            offset += speed + xm;
            xm *= 0.985;
            if (Math.abs(xm) < 0.001) xm = 0;
            items.style = `transform: translateX(${offset}px);`;
            checkStripReset();
            requestAnimationFrame(animate);
        }
    }

    function stopAutoScroll() {
        autoScroll = false;
    }

    function startAutoScroll() {
        autoScroll = true;
        animate();
    }

    function toggleautoScroll() {
        if (autoScroll) stopAutoScroll();
        else startAutoScroll();
    }

    function startUserScroll(e) {
        if (e.touches) {
            touchXLast = e.touches[0].clientX;
        }
        stopAutoScroll();
        document.addEventListener("mouseup", onUserScrollStop);
        document.addEventListener("mousemove", onUserScroll);
        document.addEventListener("touchmove", onUserScroll);
        document.addEventListener("touchend", onUserScrollStop);
    }

    function checkStripReset() {
        console.log(offset, singleStripLength);
        if (offset < -singleStripLength) {
            offset += singleStripLength;
        }

        if (offset > 0) {
            offset -= singleStripLength;
        }
    }

    function onUserScroll(e) {
        if (e.movementX) {
            //desktop
            offset += e.movementX;
            xm = e.movementX;
        } else if (e.touches) {
            //mobile
            const currX = e.touches[0].clientX;
            xm = currX - touchXLast;
            touchXLast = currX;
            offset += xm;
        }
        checkStripReset();
        items.style = `transform: translateX(${offset}px);`;
    }

    function onUserScrollStop(e) {
        document.removeEventListener("mouseup", onUserScrollStop);
        document.removeEventListener("mousemove", onUserScroll);
        document.removeEventListener("touchmove", onUserScroll);
        document.removeEventListener("touchend", onUserScrollStop);
        startAutoScroll();
    }

    onMount(() => {
        us_messages = messages.subscribe((msgs) => {
            if (msgs) buildStrip();
        });

        buildStrip();
        animate();
    });

    onDestroy(() => {
        us_messages();
    });
</script>

<div
    class="bg"
    on:touchstart={startUserScroll}
    on:mousedown={startUserScroll}
    on:keydown={(e) => {
        if (e.code === "Enter") {
            toggleautoScroll();
        }
    }}
>
    <div class="items" bind:this={items}></div>
</div>

<style>
    .bg {
        margin-top: 12px;
        width: 100%;
        height: 120px;
        background: #20202061;
        display: flex;
        overflow: hidden;
        cursor: pointer;
    }

    .items {
        display: flex;
        align-items: center;
        animation-name: move-left;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }

    :global(.messages-item) {
        display: flex;
        align-items: center;
        padding-right: 32px;
    }

    :global(.messages-img) {
        min-width: 52px;
        min-height: 52px;
        border-radius: 100px;
        border: 3px solid #ffffff9e;
        padding: 12px;
        user-select: none;
        margin: 12px;;
    }

    :global(.messages-details) {
        display: flex;
        flex-direction: column;
        align-items: start;
        color: white;
        font-size: 16px;
        font-family: "Baloo 2";
        font-weight: bolder;
        padding-left: 6px;
        white-space: nowrap;
        user-select: none;
    }

    :global(.messages-msg) {
        color: white;
        font-size: 38px;
        padding: 0;
        margin: 0;
        text-align: left;
        line-height: 32px;
        font-family: "Paytone One", Arial, Helvetica, sans-serif;
        font-style: oblique;
        white-space: nowrap;
        user-select: none;
    }

    :global(.messages-date) {
        margin-top: 6px;
        margin-left: 6px;
    }
</style>
